import React from 'react'
import GameWrapper from './GameWrapper';

export const AllGames = () => {
    const games = [
        {
            name: "Wheel of Letters",
            icon: "wol.png",
            packageName:"com.BrytStudio.WheelofLetters"
        },
        {
            name: "Dot Sweeper",
            icon: "ds.png",
            packageName:"com.BrytStudio.DotSweeper"
        },
        {
            name: "Scrambled Words",
            icon: "sw.png",
            packageName:"com.brytstudio.scrambledwords"
        },
        {
            name: "Math Round",
            icon: "mr.png",
            packageName:"com.brytstudio.mathround"
        },
        {
            name: "Fruit basket Mania",
            icon: "fbm.png",
            packageName:"com.brytstudio.fruitbasketeer"
        }
    ]
    return (
        <div className="all-games-wrapper">
            <p className="all-title">
                More Games
            </p>
            <div className="games">
                {
                    games.map(game => <GameWrapper
                        name={game.name}
                        icon={game.icon}
                        packageName={game.packageName}
                        key={game.packageName}
                    />)
                }
            </div>
        </div>
    )
}
